import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { useLinkBehavior } from '../shared';
import { getThemeConfig, SEOEyebrowLink, SEOSubjectLink, SEOSubSubjectLink } from '../styles';
import { SEOLinkType } from '../types';
/**
 * @deprecated - Start using {Link} component instead of this. We have lg size available in Link component which is similar to this.
 */

export var SEOLink = /*#__PURE__*/forwardRef(function (props, ref) {
  var linkType = props.linkType,
      nofollow = props.nofollow,
      theme = props.theme,
      linkProps = _objectWithoutProperties(props, ["linkType", "nofollow", "theme"]);

  var componentTheme = useComponentTheme({
    name: 'Link',
    theme: getThemeConfig(theme)
  });
  var relValue = nofollow ? 'nofollow' : undefined;

  var _useLinkBehavior = useLinkBehavior(linkProps),
      linkBehavior = _extends({}, _useLinkBehavior);

  switch (linkType) {
    case SEOLinkType.Subject:
      return /*#__PURE__*/React.createElement(SEOSubjectLink, _extends({
        ref: ref,
        rel: relValue
      }, linkProps, linkBehavior, {
        customTheme: componentTheme
      }));

    case SEOLinkType.SubSubject:
      return /*#__PURE__*/React.createElement(SEOSubSubjectLink, _extends({
        ref: ref,
        rel: relValue
      }, linkProps, linkBehavior, {
        customTheme: componentTheme
      }));

    case SEOLinkType.Eyebrow:
    default:
      return /*#__PURE__*/React.createElement(SEOEyebrowLink, _extends({
        ref: ref,
        rel: relValue
      }, linkProps, linkBehavior, {
        customTheme: componentTheme
      }));
  }
});
SEOLink.displayName = 'SEOLink';
SEOLink.defaultProps = {
  nofollow: true
};
export default SEOLink;